import { AuditOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { message } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GroupApplyStatus, useGroupApplyMutation } from '@/generated/graphql'

export const ApplyButton: React.FC<{ groupId: number; display?: 'icon' | 'text' | 'both' }> = ({
  groupId,
  display = 'both',
}) => {
  const { t } = useTranslation()
  const [groupApply] = useGroupApplyMutation()

  const onClick = () => async () => {
    const result = await groupApply({
      variables: {
        groupId,
      },
    })

    if (!result.data) {
      message.error('你的发送失败了，请稍后重试')
      return
    }

    switch (result.data.groupApply) {
      case GroupApplyStatus.Pending:
        message.warn(t('group.alreadyApplied'))
        return
      case GroupApplyStatus.Created:
        message.success(t('group.applySent'))
        return
      case GroupApplyStatus.Joined:
        message.success(t('group.alreadyJoined'))
        return
    }
  }

  return display === 'icon' ? (
    <div onClick={onClick()}>
      <AuditOutlined />
    </div>
  ) : (
    <Button onClick={onClick()} type='primary' ghost shape='round' icon={display === 'both' && <AuditOutlined />}>
      {t('group.apply')}
    </Button>
  )
}
